"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("react-dates/initialize");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment/moment"));

var _reactDates = require("react-dates");

var _isInclusivelyAfterDay = _interopRequireDefault(require("react-dates/lib/utils/isInclusivelyAfterDay"));

var _isInclusivelyBeforeDay = _interopRequireDefault(require("react-dates/lib/utils/isInclusivelyBeforeDay"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _ErrorDisplay = _interopRequireDefault(require("../../TextElements/FormattedTextElements/ErrorDisplay"));

var _DatePicker = require("./DatePicker.styles");

var _validate = require("../../../utils/inputValidator/validate");

var _validationTriggers = require("../../../constants/validation/validationTriggers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePicker = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DatePicker, _React$PureComponent);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "returnYears", function (minYear, maxYear) {
      var years = [];

      for (var i = minYear; i <= maxYear; i++) {
        years.push( /*#__PURE__*/_react.default.createElement("option", {
          key: "year".concat(i),
          value: i
        }, i));
      }

      return years;
    });

    _defineProperty(_assertThisInitialized(_this), "renderMonthElement", function (_ref) {
      var month = _ref.month,
          onYearSelect = _ref.onYearSelect;
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;
      var minYear = (0, _moment.default)(minDate).year();
      var maxYear = (0, _moment.default)(maxDate).year();
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("div", null, month.format('MMMM')), /*#__PURE__*/_react.default.createElement("select", {
        className: "c-year-select",
        value: month.year(),
        onChange: function onChange(e) {
          return onYearSelect(month, e.target.value);
        }
      }, _this.returnYears(minYear, maxYear)));
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$type = _ref2.type,
          type = _ref2$type === void 0 ? undefined : _ref2$type,
          _ref2$value = _ref2.value,
          value = _ref2$value === void 0 ? _this.props.selectedDate : _ref2$value;

      var stringValue = !value ? '' : value.toString();
      var currentErrors = _this.state.errors;

      var errors = _this.validate({
        type: type,
        value: stringValue,
        currentErrors: currentErrors
      });

      _this.setState({
        errors: errors
      });

      return errors;
    });

    _defineProperty(_assertThisInitialized(_this), "validateAllRules", function () {
      var selectedDate = _this.props.selectedDate;
      var currentErrors = _this.state.errors;

      var errors = _this.validate({
        value: selectedDate,
        currentErrors: currentErrors
      });

      _this.setState({
        errors: errors
      });

      return errors;
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var selectedDate = _this.props.selectedDate;

      _this.validateInput({
        type: _validationTriggers.BLUR,
        selectedDate: selectedDate
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      if (value === _this.props.selectedDate) {
        return undefined;
      }

      var errors = _this.validateInput({
        type: _validationTriggers.CHANGE,
        value: value
      });

      return _this.props.onChange && _this.props.onChange(value, errors);
    });

    _this.state = {
      errors: _toConsumableArray(props.errors),
      focused: false
    };
    _this.validate = (0, _validate.validate)({
      displayName: props.displayName,
      rules: props.validationRules
    });
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          displayName = _this$props2.displayName,
          validationRules = _this$props2.validationRules;
      this.validate = (0, _validate.validate)({
        displayName: displayName,
        rules: validationRules
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          dataTestId = _this$props3.dataTestId,
          disabled = _this$props3.disabled,
          id = _this$props3.id,
          initialVisibleMonth = _this$props3.initialVisibleMonth,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate,
          selectedDate = _this$props3.selectedDate;
      var errors = this.state.errors;
      var classPrefix = 'c-date-picker';
      var minYear = (0, _moment.default)(minDate).year();
      var maxYear = (0, _moment.default)(maxDate).year();
      var renderMonthElement = maxYear !== minYear ? this.renderMonthElement : null;
      return /*#__PURE__*/_react.default.createElement(_DatePicker.StyledDatePicker, {
        "data-test-id": dataTestId,
        className: [this.state.focused ? "".concat(classPrefix, "-focused") : '', className].join(' ')
      }, /*#__PURE__*/_react.default.createElement(_reactDates.SingleDatePicker, {
        customInputIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          dataTestId: "date-picker-calendar-icon",
          iconName: "calendar"
        }),
        initialVisibleMonth: initialVisibleMonth,
        date: selectedDate ? (0, _moment.default)(selectedDate) : undefined,
        disabled: disabled,
        focused: this.state.focused,
        hideKeyboardShortcutsPanel: true,
        id: id,
        isOutsideRange: function isOutsideRange(day) {
          return !(0, _isInclusivelyAfterDay.default)(day, (0, _moment.default)(minDate)) || !(0, _isInclusivelyBeforeDay.default)(day, (0, _moment.default)(maxDate));
        },
        noBorder: true,
        numberOfMonths: 1,
        navNext: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          className: "".concat(classPrefix, "-chevron-right"),
          colorTheme: "primary",
          dataTestId: "date-picker-chevron-right-icon",
          iconName: "chevron-right"
        }),
        navPrev: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          className: "".concat(classPrefix, "-chevron-left"),
          colorTheme: "primary",
          dataTestId: "date-picker-chevron-left-icon",
          iconName: "chevron-left"
        }),
        onDateChange: this.handleChange,
        onFocusChange: function onFocusChange(_ref3) {
          var focused = _ref3.focused;
          return _this2.setState({
            focused: focused
          }, function () {
            if (!focused) _this2.handleBlur();
          });
        },
        readOnly: true,
        renderDayContents: function renderDayContents(day) {
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "".concat(classPrefix, "-date-wrapper")
          }, day.format('D'));
        },
        renderMonthElement: renderMonthElement,
        transitionDuration: 0,
        verticalSpacing: 3
      }), /*#__PURE__*/_react.default.createElement(_ErrorDisplay.default, {
        errors: errors
      }));
    }
  }]);

  return DatePicker;
}(_react.default.PureComponent);

_defineProperty(DatePicker, "propTypes", {
  /** className hook for wrapping dom node */
  className: _propTypes.default.string,

  /** Data Test Id for testing purposes */
  dataTestId: _propTypes.default.string.isRequired,

  /** Whether the input is disabled and will not show the date picker on click */
  disabled: _propTypes.default.bool,

  /** The display name is used when presenting error messages */
  displayName: _propTypes.default.string,

  /** Flag used for indicating an error state for the input */
  errors: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Id of the component */
  id: _propTypes.default.string.isRequired,

  /** month to start on */
  initialVisibleMonth: _propTypes.default.func,

  /** Minimum selectable date (inclusive) - can be a moment obj, or date */
  minDate: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_moment.default), _propTypes.default.instanceOf(Date)]),

  /** Max selectable date (inclusive) - can be a moment obj, or date */
  maxDate: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_moment.default), _propTypes.default.instanceOf(Date)]),

  /** Event Handler for when a date is selected */
  onChange: _propTypes.default.func.isRequired,

  /** Selected date that shows in input field and highlighted within calendar  */
  selectedDate: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_moment.default), _propTypes.default.instanceOf(Date)]),
  // VALIDATION //

  /** Controls when validation is triggered */
  validationRules: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])))
});

_defineProperty(DatePicker, "defaultProps", {
  className: '',
  disabled: false,
  displayName: 'Date',
  errors: [],
  initialVisibleMonth: null,
  maxDate: (0, _moment.default)().add(60, 'days'),
  minDate: (0, _moment.default)(),
  selectedDate: (0, _moment.default)(),
  validationRules: {}
});

var _default = DatePicker;
exports.default = _default;